import { render, staticRenderFns } from "./m-form-employee.vue?vue&type=template&id=6ec63b79&scoped=true&lang=pug&"
import script from "./m-form-employee.vue?vue&type=script&lang=js&"
export * from "./m-form-employee.vue?vue&type=script&lang=js&"
import style0 from "./m-form-employee.vue?vue&type=style&index=0&id=6ec63b79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec63b79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRadio,VRadioGroup,VRow})
